import React, { useState, useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import "typeface-poppins";
import "typeface-raleway";

const Page2 = () => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.intersectionRatio >= 0.3); // Trigger animation when 30% of the component is visible
      },
      { threshold: [0.3] } // Set the threshold to 30%
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <Box
      ref={containerRef}
      sx={{
        backgroundColor: "black",
        height: "100vh",
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        overflow: "hidden",
        position: "relative",
        boxSizing: "border-box",
        padding: { xs: "0 10px", sm: "0" }, // Added padding for mobile
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          "& > div": {
            position: "absolute",
            zIndex: 0,
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)",
            transition: "opacity 0.6s ease-out, transform 0.6s ease-out",
          },
        }}
      >
        {/* Vertical Lines */}
        {[10, 20, 30, 40, 50, 60, 70, 80, 90].map((percentage) => (
          <Box
            key={percentage}
            sx={{
              left: `${percentage}%`,
              width: "1px",
              height: "100%",
              background: `linear-gradient(to bottom, #FFFFFF00, #FFFFFF${
                percentage < 50 ? "15" : "25"
              }, #FFFFFF00)`,
            }}
          />
        ))}

        {/* Horizontal Lines */}
        {[10, 20, 30, 40, 50, 60, 70, 80, 90].map((percentage) => (
          <Box
            key={percentage}
            sx={{
              top: `${percentage}%`,
              width: "100%",
              height: "1px",
              background: `linear-gradient(to right, #FFFFFF00, #FFFFFF${
                percentage < 50 ? "12" : "20"
              }, #FFFFFF00)`,
            }}
          />
        ))}
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontWeight: "medium",
            fontSize: "31px",
            fontFamily: "Raleway",
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)",
            transition: "all 0.6s ease-out",
            transitionDelay: "0.6s",
          }}
        >
          <span sx={{ color: "#939393" }}> Achieve sustainability with</span>
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontWeight: "medium",
            marginTop: "5px",
            fontSize: "32px", // Responsive font size
            fontFamily: "Raleway",
            color: "#FFFFFF",
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)",
            transition: "all 0.6s ease-out 0.2s",
            transitionDelay: "0.8s",
          }}
        >
          TowerWatch
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize:"15px", // Responsive font size
            marginTop: "20px",
            maxWidth: "400px",
            opacity: isVisible ? 0.8 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)",
            transition: "all 0.6s ease-out 0.4s",
            transitionDelay: "1s",
            fontWeight: "medium",
            fontFamily: "Raleway",
            color: "#939393",
          }}
        >
          TowerWatch aligns with the United Nations Sustainable Development
          Goals by optimizing energy use and reducing environmental impact,
          supporting a cleaner, greener future.
        </Typography>
      </Box>
    </Box>
  );
};

export default Page2;
